import { reduceMotion } from './env';

/*
  Parallax : l'image est agrandie pour pouvoir dériver dans son parent en
  overflow:hidden. <img data-parallax="0.08"> = dérive de 8 % de la taille du parent.
*/

type ParallaxItem = { el: HTMLElement; parent: HTMLElement; speed: number; visible: boolean };

let items: ParallaxItem[] = [];
let ticking = false;

function update() {
  ticking = false;
  const vh = window.innerHeight;
  for (const { el, parent, speed, visible } of items) {
    if (!visible) continue;
    const r = parent.getBoundingClientRect();
    // -1 quand le bloc entre par le bas, +1 quand il sort par le haut
    const progress = Math.max(
      -1,
      Math.min(1, (r.top + r.height / 2 - vh / 2) / (vh / 2 + r.height / 2)),
    );
    const y = -progress * speed * r.height;
    el.style.transform = `translate3d(0, ${y.toFixed(1)}px, 0) scale(${1 + speed * 2 + 0.01})`;
  }
}

function requestUpdate() {
  if (ticking) return;
  ticking = true;
  requestAnimationFrame(update);
}

export function initParallax() {
  if (reduceMotion) return;

  items = [...document.querySelectorAll<HTMLElement>('[data-parallax]')].flatMap((el) => {
    // une image dans un <picture> (variante mobile) se mesure sur le parent du picture
    const parent = el.closest('picture')?.parentElement ?? el.parentElement;
    if (!parent) return [];
    return [
      { el, parent, speed: Number.parseFloat(el.dataset.parallax || '0.08'), visible: false },
    ];
  });
  if (!items.length) return;

  const observer = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        for (const item of items) {
          if (item.parent === entry.target) item.visible = entry.isIntersecting;
        }
      }
      requestUpdate();
    },
    { rootMargin: '10% 0px' },
  );
  for (const item of items) observer.observe(item.parent);

  addEventListener('scroll', requestUpdate, { passive: true });
  addEventListener('resize', requestUpdate);
  requestUpdate();
}
